import { CheckoutSession } from '@nemuru-eng/js-api-client';
import { useState } from 'react';

import { CustomCartAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/CustomCartAlert';
import { Section } from '@/components/modules/Application/components/_shared/components/Section/Section';
import { DialogStepContent } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/_shared/components/DialogStepContent';
import { EditDownPaymentForm } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/EditCheckoutSessionDownPaymentDialog/components/EditDownPaymentForm';
import { EditDownPaymentOldValues } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/Header/CheckoutSessionActions/components/EditCheckoutSessionDownPaymentDialog/components/EditDownPaymentOldValues';
import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Text } from '@/components/shared/components/Text';

export interface EditDownPaymentProps {
  checkoutSession: CheckoutSession;
  newDownPaymentValue: number;
  setNewDownPaymentValue: (newDownPaymentValue: number) => void;
  onComplete: () => void;
  onCancel: () => void;
}

export const EditDownPayment = ({
  checkoutSession,
  newDownPaymentValue,
  setNewDownPaymentValue,
  onComplete,
  onCancel,
}: EditDownPaymentProps) => {
  const [areAlertsVisible, setAreAlertsVisible] = useState<boolean>(false);

  const hasChanges = newDownPaymentValue !== checkoutSession.downPayment?.amount.amount;

  const hasAnyAlert = !hasChanges;

  const onSubmit = () => {
    if (hasAnyAlert) {
      showAlerts();
      return;
    }

    onComplete();
  };

  const showAlerts = () => {
    if (!areAlertsVisible) setAreAlertsVisible(true);
  };

  return (
    <DialogStepContent
      titleTextId={'DOWN_PAYMENT_EDIT'}
      descriptionTextId={'DOWN_PAYMENT_EDIT_DESCRIPTION'}
      prevButtonTextId={'CANCEL'}
      nextButtonTextId={'SEND'}
      onNext={onSubmit}
      onPrev={onCancel}
      disabled={areAlertsVisible && hasAnyAlert}
    >
      <Section>
        <FlexColumn gridGap={50} width={'100%'} alignItems={'flex-end'}>
          <EditDownPaymentForm
            checkoutSession={checkoutSession}
            newDownPaymentValue={newDownPaymentValue}
            setNewDownPaymentValue={setNewDownPaymentValue}
          />
          <EditDownPaymentOldValues checkoutSession={checkoutSession} />
        </FlexColumn>
        {areAlertsVisible && (
          <FlexColumn mt={6} alignItems={'flex-end'}>
            <FlexColumn gridGap={8} maxWidth={'420px'}>
              {!hasChanges && (
                <CustomCartAlert>
                  <Text tId={'ALERT_DISABLED_DOWN_PAYMENT_EDIT'} />
                </CustomCartAlert>
              )}
            </FlexColumn>
          </FlexColumn>
        )}
      </Section>
    </DialogStepContent>
  );
};
